// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons

import {
    faCode, faHighlighter, faUser, faGraduationCap, faSchool, faUniversity, faClock,
    faHandPointUp, faHome, faEnvelope, faPhoneAlt

} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faWhatsapp, faTwitter, faInstagram, faPinterestP,
    faHackerrank,faLinkedinIn,faGithub

} from '@fortawesome/free-brands-svg-icons'

library.add(
    faGraduationCap,
    faUser,
    faCode,
    faHighlighter,
    faSchool,
    faUniversity,
    faClock,
    faHandPointUp,
    faFacebookF, faWhatsapp, faTwitter, faInstagram, faPinterestP,faHackerrank,faLinkedinIn,faGithub,
    faPhoneAlt,
    faEnvelope,
    faHome,
    // more icons go here
);